import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import InputBox from '@/components/profile/inputBox'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/idVerification/constants"

import '@/pages/profile/sections/common.css'

export default function DisplayName(props: any) {
    const { profile } = useLocalTranslation();

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            {props.marksheetOrDegreeCertCrop &&
                <div className='flex justify-center mb-[25px] profileSectionOfSectionCommonMainCon_marksheetOrDegreeCertCrop rounded-[5px] py-[35px] px-[20px]'>
                    <img 
                        style={{
                            maxWidth:"350px",
                            maxHeight:"350px"
                        }}
                        src={props.marksheetOrDegreeCertCrop} alt="marksheetOrDegreeCertCrop" />
                </div>
            }
            <p className='commonH2'>
                {profile.fields.nameAsOnMarksheetDegreeCertificate}
                <span className='text-[#FF2828]'>*</span>
            </p>
            <div className='commonCon1'>
                <p>
                    {profile.identityVerificationSection.notes.n4}
                    <b>{profile.identityVerificationSection.notes.n5}</b>
                    {profile.identityVerificationSection.notes.n6}
                    <b>{profile.identityVerificationSection.notes.n7}</b>
                    {profile.identityVerificationSection.notes.n8}
                    <b>{profile.identityVerificationSection.notes.n9}</b>
                    {profile.identityVerificationSection.notes.n10}
                </p>
            </div>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }
            <InputBox
                id={listOfSections.fullName}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.fullName)}
                value={props.value}
                placeholder={profile.placeHolders.nameAsOnMarksheetDegreeCertificate}
                showAsterisk={true}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.fullName)}
                />
            </div>
        </div>
    );
}
